import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "nav nav-tabs nav-justified" }
const _hoisted_2 = ["data-bs-target", "onClick", "aria-controls", "aria-selected"]
const _hoisted_3 = { class: "tab-content" }
const _hoisted_4 = {
  class: "tab-pane fade show active border-start border-end border-bottom p-3",
  role: "tabpanel",
  "aria-labelledby": "pills-profile-tab",
  tabindex: "0"
}

import {BTab} from ".";
import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BTabs',
  props: {
    "modelValue": {},
    "modelModifiers": {},
  },
  emits: ["update:modelValue"],
  setup(__props) {

const model = _useModel(__props, "modelValue");
const selectedTab = ref<BTab>(model.value.find((x) => x.selected));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(model.value, (tab) => {
        return (_openBlock(), _createElementBlock("li", null, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", {active: tab.selected}]),
            "data-bs-toggle": "tab",
            "data-bs-target": `#${tab.id}`,
            type: "button",
            role: "tab",
            onClick: _withModifiers(($event: any) => (selectedTab.value = tab), ["prevent"]),
            "aria-controls": tab.id,
            "aria-selected": tab.selected
          }, _toDisplayString(tab.name), 11, _hoisted_2)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(selectedTab.value.component)))
      ])
    ])
  ], 64))
}
}

})